import React, { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useAuth from '@contexts/useAuth';
import { takePendingSsoState } from '@utils/ssoSession';
import SsoStatus from './SsoStatus';

const STATE_MISMATCH = 'The sign-in attempt expired or was started in another browser. Please try again.';
const PROVIDER_ERROR = 'Your organization could not sign you in. Please try again or contact your administrator.';

const SsoCallback: React.FC = () => {
  const { completeSsoLogin } = useAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState<string | null>(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const expectedState = takePendingSsoState();

    const finish = async () => {
      if (searchParams.get('error') || !code) throw new Error(PROVIDER_ERROR);
      if (!state || state !== expectedState) throw new Error(STATE_MISMATCH);
      await completeSsoLogin(code, state);
    };
    finish().catch((err: unknown) => {
      setError(err instanceof Error ? err.message : 'Single sign-on failed');
    });
  }, [completeSsoLogin, searchParams]);

  return <SsoStatus title="Single sign-on" subtitle="Signing you in..." error={error} />;
};

export default SsoCallback;
